import React from "react";
// Components
import { StepperContainer, StepperButton, StepperIcon, StepperValue } from "./styles";
// Assets
import { minus, plus } from "../../../../assets/icons";

const Stepper = ({ value, onChange, min = 0, max, step = 1, suffix = "", width, alignRight = false }) => {
  const decrease = () => onChange(Math.max(value - step, min));
  const increase = () => onChange(Math.min(value + step, max));

  return (
    <StepperContainer $width={width} $alignRight={alignRight}>
      <StepperButton type="button" onClick={decrease} disabled={value <= min} aria-label="-">
        <StepperIcon src={minus} alt="" />
      </StepperButton>
      <StepperValue>{`${value}${suffix}`}</StepperValue>
      <StepperButton type="button" onClick={increase} disabled={value >= max} aria-label="+">
        <StepperIcon src={plus} alt="" />
      </StepperButton>
    </StepperContainer>
  );
};

export default Stepper;
